import React, { useEffect } from "react";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faXmark } from "@fortawesome/free-solid-svg-icons";
import "./SearchInput.scss";

const SearchInput = ({
  Value,
  onChange,
  placeholder = "Search",
  onSearch,
  showIcon = "true",
  selectedSearchValue,
}) => {
  const [value, setValue] = useState(selectedSearchValue);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSearch(value.trim());
    }
  };

  const handleClear = () => {
    onChange("");
    setValue("");
    onSearch?.("");
  };

  useEffect(() => {
    setValue(selectedSearchValue);
  }, [selectedSearchValue]);
  return (
    // <div className="search-input-wrapper w-100" style={{ width }}>
    //   {/* <span className="search-input-icon">🔍</span> */}
    //   <FontAwesomeIcon icon={faMagnifyingGlass} />
    //   <input
    //     className="w-100 py-2 px-4"
    //     type="text"
    //     value={value}
    //     placeholder={placeholder}
    //     onChange={(e) => onChange(e.target.value)}
    //   />
    // </div>
    <div className="d-flex  position-relative">
      {showIcon && (
        <span className="py-2 position-absolute top-0 start-0 ms-3 text-theme">
          <FontAwesomeIcon icon={faMagnifyingGlass} />
        </span>
      )}
      <input
        type="text"
        className={`w-100 py-2  rounded-1 border border-secondary-subtle ${showIcon ? "ps-5" : "ps-3"}`}
        placeholder={placeholder}
        value={value || selectedSearchValue || ""}
        // onChange={(e) => onChange(e.target.value)}
        onChange={(e) => {
          const value = e.target.value;
          onChange(value);
          setValue(value);
        }}
        onKeyDown={handleKeyDown}
      />
      {value && (
        <span
          className="py-2 position-absolute top-0 end-0 me-2"
          onClick={handleClear}
        >
          <FontAwesomeIcon icon={faXmark} style={{ color: "red" }} />
        </span>
      )}
    </div>
  );
};

export default SearchInput;
